"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var material_1 = require("@mui/material");
var LabelWithTooltipComponent_1 = __importDefault(require("../MessageComponents/LabelWithTooltipComponent"));
var SwitchComponent = function (props) {
    var color = props.color || 'primary';
    var size = props.size || 'medium';
    var _a = react_1.useState(props.checked), checked = _a[0], setChecked = _a[1];
    react_1.useEffect(function () {
        setChecked(props.checked);
    }, [props.checked]);
    var handleChange = function (checked) {
        setChecked(checked);
        props.onChange && props.onChange(checked);
    };
    return (react_1.default.createElement(material_1.FormControlLabel, { control: react_1.default.createElement(material_1.Switch, { checked: checked, size: size, id: props.id, disabled: props.disabled, onChange: (function (event) { return handleChange(event.target.checked); }), color: color, name: props.name }), label: react_1.default.createElement(material_1.Typography, { variant: 'body2', style: { display: 'flex' } },
            react_1.default.createElement(LabelWithTooltipComponent_1.default, { label: props.label, description: props.description })) }));
};
exports.default = SwitchComponent;
